import { Observable } from "rxjs";

export abstract class IImageRepository {
    abstract getImages(fileInfo: any): Observable<any>;
    abstract getImagesOptimized(fileInfo: any, size: string): Observable<any>;
    abstract deleteImage(fileId: string, fileType: string): Observable<boolean>;
}